import { gql } from '@apollo/client';

const EMAIL_EPOD = gql`
  mutation customerPortalEmailEpod($input: CustomerPortalEPODEmailInput!) {
    customerPortalEmailEpod(input: $input)
  }
`;

export { EMAIL_EPOD };
